import axios from 'axios'
import Vue from 'vue'
import {SURFACES, buildPayload} from '@/components/filters/capabilities'

const state = {
    filter: {
        projects: [],
        jobs: [],
        tags: [],
        fromDt: null,
        thruDt: null,
        onlyUntagged: true,
        respIdSearchFreeForm: null

    }
}

const getters = {}

const mutations = {
    setFilter(state, filter) {
        Object.assign(state.filter, filter)
    },
    clearFilter(state) {
        state.filter = {
            projects: [],
            jobs: [],
            tags: [],
            fromDt: null,
            thruDt: null,
            onlyUntagged: true,
            respIdSearchFreeForm: null
        }
    },

}


const actions = {
    // IT-707 P2.1: key names and value coercion moved to the shared capability
    // builder. This action keeps its own transport and its own success handler.
    getPhotosByFilter(context, filter){
        let payload = buildPayload(SURFACES.PHOTO_TAGGING, filter);

        return axios.post('/api/photos/filter_photos/', payload)
            .then(response => {
                this.state.photos.photos = response.data
            })
            .catch(e => {
                console.log(e)
            })
    }

}

export default {
    state,
    getters,
    mutations,
    actions
}
